// import { Chart } from "chart.js/auto";
import { ArcElement } from "chart.js";
import {Line} from "react-chartjs-2";
import { Pie } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, LineElement, BarElement, BarController, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend} from 'chart.js';
import fetchGithubProfileData from "./githubProfileData";
import { useEffect, useState} from "react";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip,Legend, ArcElement, BarElement, BarController); 
const BarChart = () => {
  const [reposData, setReposData] = useState([]);
  const searchParams = new URLSearchParams(window.location.search);
  const username = searchParams.get("user");
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchGithubProfileData(username);
      if (data) {
        // Extract commit data
        // const commitData = data.commit_data;
        const sortedRepos = data.commit_data.sort(
          (a, b) => b.stargazers_count - a.stargazers_count
        );
        
        // Take top 10 or 15 repos
        const topRepos = sortedRepos.slice(0, 5);
        // Map through the commit data and extract relevant information
        const reposData = topRepos.map((repoData) => ({
          name: repoData.repo_name,
          stars: repoData.stars,  // Include stars count
        }));

        setReposData(reposData);
      }
    };

    fetchData();
  }, [username]);

  // Random color generator function
  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // Prepare data for the Bar chart
  const chartData = {
    labels: reposData.map((repo) => repo.name),
    datasets: [
      {
        label: 'Stars Count',
        data: reposData.map((repo) => repo.stars),
        backgroundColor: reposData.map(() => getRandomColor()),
        borderColor: reposData.map(() => 'rgb(75, 192, 192)'),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };
  return <Bar data={chartData} options={options} />;
};
const PieChart = () => {
  const [languageScores, setLanguageScores] = useState([]);
  const searchParams = new URLSearchParams(window.location.search);
  const username = searchParams.get("user");
  useEffect(() => {
    const fetchData = async () => {
      // Fetch the GitHub data (including language scores)
      const data = await fetchGithubProfileData(username);

      if (data && data.language_scores) {
        // Filter out any entries with null or undefined language
        const validLanguageScores = data.language_scores.filter(
          (score) => score.language && score.score > 0
        );

        setLanguageScores(validLanguageScores);
      }
    };

    fetchData();
  }, [username]);

  // Prepare the chart data using the fetched language scores
  const data = {
    labels: languageScores.map((score) => score.language),
    datasets: [
      {
        label: "Most Used Languages",
        data: languageScores.map((score) => score.score),
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          // Add more colors if needed
        ],
        borderColor: [
          'rgb(255, 99, 132)',
          'rgb(255, 159, 64)',
          'rgb(255, 205, 86)',
          'rgb(75, 192, 192)',
          'rgb(153, 102, 255)',
          'rgb(255, 159, 64)',
          // Add more border colors if needed
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  return <Pie data={data} options={options} />;
};
const LineChart = () => {
  const [labels, setLabels] = useState([]);
  const [dataValues, setDataValues] = useState([]);
  const searchParams = new URLSearchParams(window.location.search);
  const username = searchParams.get("user");
  useEffect(() => {
      const fetchData = async () => {
          const data = await fetchGithubProfileData(username);
          if (data && data.commit_data) {
              const currentYear = new Date().getFullYear();

              // Collect all commit dates in the current year
              const commitDates = data.commit_data
                  .flatMap(repo => repo.commits)
                  .map(commit => new Date(commit.date)) // Convert to Date object
                  .filter(date => date.getFullYear() === currentYear) // Keep only this year's commits
                  .map(date => date.toISOString().split("T")[0]); // Format as YYYY-MM-DD

              // Count commits per date
              const dateCounts = commitDates.reduce((acc, date) => {
                  acc[date] = (acc[date] || 0) + 1;
                  return acc;
              }, {});

              // Sort dates in chronological order
              const sortedDates = Object.keys(dateCounts).sort((a, b) => new Date(a) - new Date(b));

              setLabels(sortedDates); // Set X-axis labels
              setDataValues(sortedDates.map(date => dateCounts[date])); // Set commit counts per date
          }
      };

      fetchData();
  }, [username]);

  const data = {
      labels: labels,
      datasets: [
          {
              label: "Commits Per Day",
              data: dataValues,
              fill: false,
              backgroundColor: "rgba(75,192,192,0.4)",
              borderColor: "rgba(75,192,192,1)",
          },
      ],
  };

  const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
          legend: {
              position: "top",
          },
      },
  };

  return <Line data={data} options={options} />;
};

function StatsContainer(){
    return(
        <section className="section--lg statsSection">
            <div className="statsContainer c1">
                <h2 style={{textAlign:"center", paddingBottom:"3rem"}}>Commits History</h2>
                <LineChart/>
            </div>
            
            <div className="statsContainer c2">
                <h2 style={{textAlign:"center", paddingBlock:"2rem"}}>Most Used Language</h2>
                <PieChart/>
            </div>
            <div className="statsContainer c3">
                <h2 style={{textAlign:"center", paddingBlock:"2rem"}}>Most Starred</h2>
                <BarChart/>
            </div>
        </section>
    );
}

export default StatsContainer;